import DOMPurify from 'dompurify';
import { marked, type MarkedOptions } from 'marked';

marked.use({ gfm: true, breaks: true });

// `input` stays allowed: GFM task lists render disabled checkboxes.
const FORBID_TAGS = ['form', 'button', 'textarea', 'select', 'style'];

/**
 * Markdown → sanitized HTML, safe for `dangerouslySetInnerHTML`.
 * Sources include client-uploaded audit reports and LLM output, so raw HTML
 * (scripts, event handlers, javascript: URLs, fake login forms) must never reach the DOM.
 */
export function renderMarkdown(source: string, options?: MarkedOptions): string {
  const html = marked.parse(source, { ...options, async: false }) as string;
  return DOMPurify.sanitize(html, { FORBID_TAGS });
}
